import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as entry from '../entry'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: entry.RESOURCE.payload.dimension.partialId,
      partialId: entry.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: true,
    description: 'Is this organization actually using the room?',
    isOptional: false,
    name: 'Is Occupier?',
    partialId: PartialId.Standard.create('is_occupier'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
